import React, { useContext } from 'react'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import { CartContext } from '../../../context/cartContext'
import { useImpersonation } from '../../../context/impersonationContext'
import ShoppingCart from './shoppingCart'
import BurgerMenuIcon from '../../../icons/burgerMenuIcon'
import CloseIcon from '../../../icons/closeIcon'

interface MobileHeaderProps {
  onSidebarToggle: () => void;
  isSidebarOpen: boolean;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({ onSidebarToggle, isSidebarOpen }) => {
  const { cart } = useContext(CartContext)
  const { isImpersonating } = useImpersonation()

  return (
    <AppBar
      position='absolute'
      sx={{
        backgroundColor: '#F1F1F2',
        boxShadow: 'none',
        height: '95px',
        top: isImpersonating ? '60px' : '0px',
        zIndex: 1200 // Ensure header stays above sidebar
      }}
    >
      <Toolbar
        sx={{
          minHeight: 'auto!important',
          padding: '0!important',
          height: '100%',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        {/* Logo on the left */}
        <Box sx={{ flex: '0 0 auto', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <img src='/logo.svg' alt='Company Logo' style={{ width: 178, marginLeft: 16 }} />
        </Box>
        {/* Right side: burger menu/close icon and cart */}
        <Box sx={{ flex: '0 0 auto', display: 'flex', alignItems: 'center', gap: 1, height: '100%' }}>
          <IconButton
            aria-label={isSidebarOpen ? 'close sidebar' : 'open sidebar'}
            edge='end'
            onClick={onSidebarToggle}
            sx={{
              ml: 1,
              marginHeight: '0px!important',
              paddingY: '0px!important',
              mr: '8px',
              height: '2.4rem!important',
              width: '2.4rem!important',
              '& svg': {
                transform: isSidebarOpen ? 'scale(1.4)' : 'scale(1)',
              }
            }}
          >
            {isSidebarOpen ? <CloseIcon /> : <BurgerMenuIcon />}
          </IconButton>
          <ShoppingCart content={cart !== null ? cart : 0} isMobile={true} />
        </Box>
      </Toolbar>
    </AppBar>
  )
}

export default MobileHeader
